import { useEffect, useState, useRef } from 'react'
import {useNavigate } from 'react-router'
import * as Yup from 'yup';
import { useFormik } from 'formik'
import { MatchageConstanteFormComponent, MatchageConstanteGenerateYup } from '../../ConstantesConfig/MatchageConstantes'
import axios from 'axios'
import { useAuthUser } from '../../../auth'
import { errorCss, getValue } from '../../Utils/formik-util';
import { Modal } from "bootstrap";
import { useToast } from '../../../toastHook'
import { InputTextarea } from 'primereact/inputtextarea';
import { InfoAndCacheRefreshComponent } from '../AOOnDemand'

export const AOReadMatchComponent = () => {

    const { display } = useToast();
    const navigate = useNavigate();
    const { checkRole } = useAuthUser();
    const [resultKey, setResultKey] = useState(null);
    const [hasExplain, setHasExplain] = useState(false);
    const [avalaibleComptes, setAvalaibleComptes] = useState([]);
    const [copyCliboardError, setCopyClipboardError] = useState('');
    const canExplain = checkRole('Pocahontas_Explain');
    const canQueryCustom = checkRole('Pocahontas_RunCustom');
    const aoHtmlModalRef = useRef();
    const [isRunning, setIsRunning] = useState(false);

    const testAOIsThere = (item, context) => {
        if (!context.parent.compte) {
            return false;
        }

        const compte = avalaibleComptes.find(x => x.name === context.parent.compte);

        if (!compte) {
            return false;
        }

        if (compte.isHtml) {
            return context.parent.aoHtml;
        }
        else {
            return context.parent.aoBase64;
        }
    }

    var validationSchema = Yup.object().shape({
        aoHtml: Yup.string().test("aoHtml","il faut un ao", testAOIsThere),
        aoBase64: Yup.string().test("aoBase64","il faut un ao", testAOIsThere),
        compte: Yup.string().required("le compte est requis"),
    });

    if (canQueryCustom) {
        validationSchema = Yup.object().shape({
            aoHtml: Yup.string().test("aoHtml","il faut un ao", testAOIsThere),
            aoBase64: Yup.string().test("aoBase64","il faut un ao", testAOIsThere),
            compte: Yup.string().required("le compte est requis"),
            configuration: MatchageConstanteGenerateYup()
        });
    }




    const formik = useFormik({
        initialValues: {
            configuration: {

            },
            aoHtml: '',
            compte : ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {

            if (!canExplain) {
                formik.setFieldValue('configuration.MustExplain', false);
            }

            setHasExplain(formik.values.configuration.MustExplain);

            setIsRunning(true);

            axios.post('/api/aoreadondemand/calculate', values).then(response => {

                setIsRunning(false);

                if (response.data) {
                    setResultKey(response.data);
                }
            });


            

            
        },
        enableReinitialize: true
    });

    useEffect(() => {

        if (!canQueryCustom) {
            return;
        }

        axios.get("/api/MatchageConfigurationforall")
            .then(response => {
                if (response.data) {
                    formik.setValues({ ...formik.initialValues, configuration: response.data })
                }
            })
    }, []);

    useEffect(() => {
        axios.get("/api/aoutility/enginereaders")
            .then(response => {
                if (response.data) {

                    response.data.sort();

                    setAvalaibleComptes(response.data);
                }
            });
    }, []);

    useEffect(() => {

        if (!resultKey) {
            return;
        }

        navigate("/aos/readmatch/detail/" + resultKey);
    });

    const handleChangeConfiguration = e => {
        const name = e.target.name;

        let value = getValue(e.target);

        formik.setFieldValue('configuration.' + name, value);
    }

    const openAoHtmlModal = () => {
        const modal = Modal.getOrCreateInstance(aoHtmlModalRef.current);
        modal.show();
    }

    const displayClipboardErrorMessage = message => {
        setCopyClipboardError(message);

        setTimeout(() => setCopyClipboardError(''), 8_000);
    }

    const readClipboard = () => {
        navigator.clipboard.read().then(clipboard => {

            for (var item of clipboard) {

                if (item.types.includes("text/html")) {
                    item.getType("text/html").then(blob => {
                        blob.text().then(t => {
                            formik.setFieldValue("aoHtml", t);
                        });
                    });

                    return;
                }
            }

            displayClipboardErrorMessage("le presse papier ne contient pas de text html");

        })
            .catch(e => displayClipboardErrorMessage("erreur avec le presse papier, vérifiez que vous avez autorisé le presse papier dans le navigateur"));
    }

    let writeAo = <></>
    if (avalaibleComptes && formik) {
        const foundCompte = avalaibleComptes.find(x => x.name === formik.values.compte)

        if (foundCompte?.isHtml) {
            writeAo = <div className="alert alert-info">Vous devez copier ici le code source de l'appel d'offre que vous aller étudier,
                <ul><li> soit  clique droit sur la page dans votre navigateur, sélection code source (controle + u), puis copiez.</li>
                    <li>sinon si cela ne marche pas dans la page ctr+a , ctr+c et cliquer sur le bouton copier depuis le presse papier</li></ul>
                {formik.errors.aoHtml ? <div className="text-danger mt-2"  >{formik.errors.aoHtml}</div> : <></>}
                <button type="button"  className="btn btn-outline-primary mt-2" onClick={openAoHtmlModal} >copier le code ici</button>
            </div>
        }
        else if (foundCompte) {
            writeAo =
                   <div className="mb-3">
                    <label htmlFor="compte" className="form-label">ao</label>
                    <input type="file" className={`form-select ${errorCss(formik.errors.aoBase64)}`} aria-describedby="aoHelp" onChange={e => {

                        if (e.target.files.length === 1) {
                            var fileReader = new FileReader();
                            fileReader.onload = function () {
                                const byteArray = new Uint8Array(this.result);

                                const bufferSize = 1024;
                                let stringBuffer = [];
                                for (let index = 0; index < byteArray.length; index += bufferSize) {
                                    let subArray;
                                    let nextIndex = index + bufferSize;
                                    if (nextIndex > byteArray.length) {
                                        subArray = byteArray.subarray(index);
                                    } else {
                                        subArray = byteArray.subarray(index, nextIndex);
                                    }
                                    let tempString = "";
                                    for (let i = 0; i < subArray.length; i++) {
                                        tempString += String.fromCharCode(subArray[i]);
                                    }
                                    stringBuffer.push(tempString);
                                }

                                const base64String = btoa(stringBuffer.join(''));
                                formik.setFieldValue("aoBase64", base64String);
                            }
                            fileReader.readAsArrayBuffer(e.target.files[0]);
                            
                        }

                    }}>
                          
                    </input>
                    <div id="aoHelp" className="form-text">appel d'offre à utiliser pour l'analyse</div>
                    {formik.errors.aoBase64 ? (
                        <div className="invalid-feedback">{formik.errors.aoBase64}</div>
                    ) : (<></>)}
                    </div>
        }
    }


    return <div>
             <InfoAndCacheRefreshComponent >Cette page vous permet de faire des matchages d'ao à la volée avec le code source d'un ao</InfoAndCacheRefreshComponent>
    <div className="card mb-4">
        <div className="card-header">
            <h3> Lecture et calcul des scores d'un ao depuis les sources</h3>
        </div>
            <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                    {
                        canQueryCustom ?
                        <MatchageConstanteFormComponent values={formik.values.configuration} handleChange={handleChangeConfiguration} errors={formik.errors.configuration} hasExplainAlert={false} hasExplain={canExplain} />
                        : <></>
                    }
                    { writeAo }
                <div className="mb-3">
                    <label htmlFor="compte" className="form-label">Compte</label>
                    <select name="compte" className={`form-select ${errorCss(formik.errors.compte)}` } id="compte" aria-describedby="compteHelp" required value={formik.values.compte} onChange={formik.handleChange}>
                            <option value="" hidden>selectionnez</option>
                            {avalaibleComptes.map(x => <option key={x.name} value={x.name}>{x.name}</option>)}
                    </select>
                    <div id="compteHelp" className="form-text">le compte à utiliser pour parser l'appel d'offre</div>
                    {formik.errors.compte ? (
                        <div className="invalid-feedback">{formik.errors.compte}</div>
                    ) : (<></>)}
                    </div>
                    <div className="card-footer row justify-content-center" ><button type="submit" className="btn btn-lg btn-primary col-4 d-flex justify-content-center align-items-center gap-3 " disabled={isRunning} ><span>Lancer le parsing et le calcul</span> { isRunning ? <span className="spinner-border"></span>  : <></>}</button></div>
                </form>
        </div>
        </div>
        <div ref={aoHtmlModalRef} className="modal fade" id="fullscreenModal" tabIndex="-1" aria-labelledby="aoHtmlModal" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="aoHtmlModal">Code source de l'ao</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                    </div>
                    <div className="modal-body">
                        {copyCliboardError ? <div className="text-danger">{copyCliboardError}</div> : <></>}
                        <InputTextarea value={formik.values.aoHtml} style={{ width: "100%", height: "100%" }} onChange={(e) => formik.setFieldValue("aoHtml", e.target.value)} rows={5} cols={30} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={ () => readClipboard() }>Export Html depuis le presse papier</button>
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
}





